export const RESET_SEGMENT = segment => `RESET_SEGMENT_${segment}`;
export const ADD_VALUE_TO_SEGMENT = segment => `ADD_VALUE_TO_SEGMENT_${segment}`;

export const SET_IS_FETCHING = 'ANALYTICS_SET_IS_FETCHING';
export const UNSET_IS_FETCHING = 'ANALYTICS_UNSET_IS_FETCHING';
